import { Report } from '../../dtos/Report'
import actions, {
    DeleteReportAction,
    FetchReportsAction,
    SelectReportAction,
    SetReportsAction,
    SoftDeleteReportAction
} from './actions'

export const actionCreators = {
    fetchReports: (serviceContractOnly: boolean) => ({
        type: actions.FETCH_REPORTS,
        serviceContractOnly
    } as FetchReportsAction),
    setReports: (reports: Report[]) => ({ type: actions.SET_REPORTS, reports } as SetReportsAction),
    selectReport: (report: Report) => ({ type: actions.SELECT_REPORT, report } as SelectReportAction),
    deleteReport: (reportId: number) => ({ type: actions.DELETE_REPORT, reportId } as DeleteReportAction),
    softDeleteReport: (reportId: number) => ({ type: actions.SOFT_DELETE_REPORT, reportId } as SoftDeleteReportAction)
}
